import { queryOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';

import type {
  StandbyActiveEntryQueryKey,
  StandbyActiveEntryResponse,
} from './types';

/**
 * Contract confirmed against squire-api PR #19228
 * (feat/SQR-14762-standby-customer-join):
 * `GET /v1/standby-list/customer/:shopId/active-entry` -> 200
 * `{ entryId: string | null, statusUrl: string | null }`.
 */
export const standbyActiveEntryQuery = (shopId: string, customerId: string) => {
  const fetchActiveEntry = async (): Promise<StandbyActiveEntryResponse> => {
    const { data } = await apiClient.get<StandbyActiveEntryResponse>(
      `/v1/standby-list/customer/${shopId}/active-entry`,
    );

    return data;
  };

  return queryOptions<
    StandbyActiveEntryResponse,
    Error,
    StandbyActiveEntryResponse,
    StandbyActiveEntryQueryKey
  >({
    queryKey: ['standby', 'activeEntry', shopId, customerId],
    queryFn: fetchActiveEntry,
    enabled: !!shopId && !!customerId,
    // A stale positive would wrongly block the funnel and a stale negative
    // would let a client re-enter one they already joined — keep this fresh
    // rather than caching it like the shop/service catalog reads.
    staleTime: 0,
    // The guard fails open on error and the join-time 409 is the real
    // backstop, so a failed lookup should surface at once rather than stall
    // the funnel behind three silent retries — matches the stylist/service reads.
    retry: false,
  });
};
